import React from 'react'

export const NoMatch = () => {
    return (
        <div>
            Page Not Found
        </div>
    )
}